import { Signal } from "signals";
import { Connector } from "slotworks/server/connectors/connector";
import Contract from "slotworks/utils/contracts/contract";
import Logger from "slotworks/utils/logger";

class QuickfireVConnector implements Connector {

    private errorSignal: Signal = new Signal();

    private exceptionalErrorCodes = ["512"];

    public sendRequest(request: any): Contract<{}> {

        const packetConfig = {
            basePkt: request,
            mid: mgsCasinoParams.moduleID,
            cid: mgsCasinoParams.clientID,
            verb: "AdvSlot",
            pktAttributes: { version: 5 }
        };

        return new Contract((resolve) => V.API.Core.sendPacket(packetConfig, (packet: QuickfireResponsePacket) => {

            this.log(JSON.stringify(packet));

            if (this.hasError(packet)) {
                return this.handleError(packet);
            }

            resolve(packet);
        }, this));
    }

    public onError(method: (message: string, fatal?: boolean) => void) {
        this.errorSignal.add(method);
    }

    public close(): void {
        // Nothing to do
    }

    private log(message: string) {
        Logger.info("%c Quickfire V Connector ", "background: #ffb347; color: #fff", message);
    }

    private hasError(packet: QuickfireResponsePacket) {
        const standardQuickfireError = packet.Response.Error;
        return this.isWillamHillError(packet) || standardQuickfireError;
    }

    /**
     * William Hill errors require special treatment and get passed to handleFatalError. We have been given a very small
     * list of exceptional error codes which can come back as WilliamHill style errors but should be treated as normal
     * errors.
     *
     * @param packet
     */
    private handleError(packet: QuickfireResponsePacket) {
        if (this.isUnknownWilliamHillError(packet)) {
            const errorDetails = V.API.Core.getErrorDetails(packet, false);
            V.API.Core.handleFatalError(errorDetails);
            return;
        }

        this.errorSignal.dispatch(packet.Response.Error.attributes.text);
    }

    private isWillamHillError(packet: QuickfireResponsePacket) {
        return packet.Id.attributes.verb === "Error";
    }

    private isUnknownWilliamHillError(packet: QuickfireResponsePacket) {

        if (!this.isWillamHillError(packet)) {
            return false;
        }

        const serverCode = packet.Response.Error.attributes.servercode;
        const isUnexpected = this.exceptionalErrorCodes.indexOf(serverCode) < 0;

        return isUnexpected;
    }
}

export default new QuickfireVConnector();
